export default function HonestyMeter({ score = 0, showLabel = true }) {
  const s = Math.max(0, Math.min(100, score));
  const isHigh = s >= 85;
  return (
    <div className="min-w-[130px]" data-testid="honesty-meter">
      {showLabel && (
        <div className="font-ui text-[10px] mb-1 flex justify-between">
          <span>AI Honesty</span>
          <span className={isHigh ? "text-[#FF3333]" : ""} data-testid="honesty-score-value">{s}%</span>
        </div>
      )}
      <div className={`meter ${isHigh ? "red" : ""}`}>
        <span style={{ width: `${s}%` }} />
      </div>
    </div>
  );
}
